import { ValueType } from "./data";

const currencyFormatter = new Intl.NumberFormat("en-GB", {
  currency: "GBP",
  style: "currency",
  maximumFractionDigits: 0,
  minimumFractionDigits: 0,
});

export const calculateResults = (propertyValue: number, knownValue: number, valueType: string) => {
  let result1 = "";
  let result2 = "";
  if (valueType === ValueType.DEPOSIT_AMOUNT) {
    result1 = `${Math.floor(((propertyValue - knownValue) / propertyValue) * 100)}%`;
    result2 = `${currencyFormatter.format(propertyValue - knownValue)}`;
  }
  if (valueType === ValueType.LOAN_AMOUNT) {
    result1 = `${Math.floor((knownValue / propertyValue) * 100)}%`;
    result2 = `${currencyFormatter.format(propertyValue - knownValue)}`;
  }
  if (valueType === ValueType.LTV_PERCENTAGE) {
    result1 = `${currencyFormatter.format((propertyValue * knownValue) / 100)}`;
    result2 = `${currencyFormatter.format(propertyValue - ((propertyValue * knownValue) / 100))}`;
  }
  return [result1, result2];
};
